export const piCandidatesList = [
  { region: "Tanger-Tétouan-Al Hoceïma", province: "Tanger-Assilah", nom: "Hamami", prenom: "Mohamed", nomAr: "الحمامي", prenomAr: "محمد", genre: "M" },
  { region: "Tanger-Tétouan-Al Hoceïma", province: "Tétouan", nom: "Toub", prenom: "Monssef", nomAr: "الطوب", prenomAr: "منصف", genre: "M" },
  { region: "Tanger-Tétouan-Al Hoceïma", province: "Fahs-Anjra", nom: "Saour Mansouri", prenom: "Driss", nomAr: "ساور المنصوري", prenomAr: "إدريس", genre: "M" },
  { region: "Tanger-Tétouan-Al Hoceïma", province: "Larache", nom: "Baraka", prenom: "Nizar", nomAr: "بركة", prenomAr: "نزار", genre: "M" },
  { region: "Tanger-Tétouan-Al Hoceïma", province: "Chefchaouen", nom: "Amine Mettioui", prenom: "Ahmed", nomAr: "أمين المتبوبي", prenomAr: "أحمد", genre: "M" },
  { region: "Tanger-Tétouan-Al Hoceïma", province: "Ouezzane", nom: "Lachheb", prenom: "Abdelaziz", nomAr: "العزيز لشعب", prenomAr: "عبد", genre: "M" },
  { region: "L'Oriental", province: "Oujda-Angad", nom: "Hejira", prenom: "Omar", nomAr: "حجيرة", prenomAr: "عمر", genre: "M" },
  { region: "L'Oriental", province: "Driouch", nom: "El Fettahi", prenom: "Abdelmounaim", nomAr: "المنعم فتاحي", prenomAr: "عبد", genre: "M" },
  { region: "L'Oriental", province: "Berkane", nom: "Benabdellah", prenom: "Hakim", nomAr: "بن عبد الله", prenomAr: "حكيم", genre: "M" },
  { region: "L'Oriental", province: "Taourirt", nom: "Azirar", prenom: "Mohamed", nomAr: "أبرار", prenomAr: "محمد", genre: "M" },
  { region: "L'Oriental", province: "Jerada", nom: "El Jaghaoui", prenom: "Ali", nomAr: "جفاوي", prenomAr: "علي", genre: "M" },
  { region: "L'Oriental", province: "Figuig", nom: "Kada", prenom: "Lekbir", nomAr: "لكبير", prenomAr: "قادة", genre: "M" },
  { region: "Fès-Meknès", province: "Fès-Sud", nom: "Amraoui", prenom: "Allal", nomAr: "العمراوي", prenomAr: "علال", genre: "M" },
  { region: "Fès-Meknès", province: "Moulay Yacoub", nom: "Chehbi", prenom: "Hassan", nomAr: "الشهبي", prenomAr: "حسن", genre: "M" },
  { region: "Fès-Meknès", province: "El Hajeb", nom: "Laamoud", prenom: "Lahcen", nomAr: "العمود", prenomAr: "لحسن", genre: "M" },
  { region: "Fès-Meknès", province: "Sefrou", nom: "Layachi", prenom: "Ibrahim", nomAr: "العياشي", prenomAr: "ابراهيم", genre: "M" },
  { region: "Fès-Meknès", province: "Boulemane", nom: "Laaouina", prenom: "Ahmed", nomAr: "العوينة", prenomAr: "أحمد", genre: "M" },
  { region: "Fès-Meknès", province: "Karia-Ghafsay", nom: "Tahri", prenom: "Mfeddal", nomAr: "طاهر", prenomAr: "المفضل", genre: "M" },
  { region: "Fès-Meknès", province: "Taza", nom: "Chantir", prenom: "Mounir", nomAr: "شنتير", prenomAr: "منير", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Rabat-Océan", nom: "Bouzidi", prenom: "Abdelilah", nomAr: "الله البوزيدي", prenomAr: "عبد", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Salé-Jadida", nom: "Kerboub", prenom: "Mohamed", nomAr: "كربوب", prenomAr: "محمد", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Skhirate-Témara", nom: "Sajed", prenom: "Rachid", nomAr: "ساجد", prenomAr: "رشيد", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Kénitra", nom: "Azri", prenom: "Mohamed", nomAr: "العزري", prenomAr: "محمد", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Khémisset-Oulmès", nom: "Himi", prenom: "Mohamed", nomAr: "حيمي", prenomAr: "محمد", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Tiflet-Rommani", nom: "Taghouane", prenom: "Bouamar", nomAr: "تغوان", prenomAr: "بوعمر", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Sidi Kacem", nom: "El Hafed", prenom: "Mohamed", nomAr: "الحافظ", prenomAr: "محمد", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Sidi Slimane", nom: "Radi", prenom: "Noureddine", nomAr: "الدين الراضي", prenomAr: "نور", genre: "M" },
  { region: "Béni Mellal-Khénifra", province: "Béni Mellal", nom: "Khayr", prenom: "Madiha", nomAr: "خبير", prenomAr: "مديحة", genre: "F" },
  { region: "Béni Mellal-Khénifra", province: "Bzou-Ouaouizeght", nom: "El Houcine", prenom: "Jamal", nomAr: "الحسين", prenomAr: "جمال", genre: "M" },
  { region: "Béni Mellal-Khénifra", province: "Fquih Ben Salah", nom: "El Mekkaoui", prenom: "Rahal", nomAr: "المكاوي", prenomAr: "رحال", genre: "M" },
  { region: "Béni Mellal-Khénifra", province: "Khénifra", nom: "Oughbal", prenom: "Saleh", nomAr: "أوغبال", prenomAr: "صالح", genre: "M" },
  { region: "Béni Mellal-Khénifra", province: "Khouribga", nom: "Zakrani", prenom: "M'hamed", nomAr: "زكراني", prenomAr: "محمد", genre: "M" },
  { region: "Casablanca-Settat", province: "Casablanca-Anfa", nom: "Berkani", prenom: "Hassan", nomAr: "بركاني", prenomAr: "حسن", genre: "M" },
  { region: "Casablanca-Settat", province: "Al Fida-Mers Sultan", nom: "Nasrollah", prenom: "Lhoucine", nomAr: "نصر الله", prenomAr: "الحسين", genre: "M" },
  { region: "Casablanca-Settat", province: "Aïn Sebaâ-Hay Mohammadi", nom: "Afilal", prenom: "Rachid", nomAr: "أفيلال", prenomAr: "رشيد", genre: "M" },
  { region: "Casablanca-Settat", province: "Sidi Bernoussi", nom: "El Haid", prenom: "Hicham", nomAr: "الحيد", prenomAr: "هشام", genre: "M" },
  { region: "Casablanca-Settat", province: "Hay Hassani", nom: "Berkani", prenom: "Mohamed", nomAr: "الركاني", prenomAr: "محمد", genre: "M" },
  { region: "Casablanca-Settat", province: "Ben M'sik", nom: "Thiriss", prenom: "Mahfoud", nomAr: "التهيريس", prenomAr: "محفوظ", genre: "M" },
  { region: "Casablanca-Settat", province: "Moulay Rachid", nom: "Mhadi", prenom: "Abdelilah", nomAr: "الله امهادي", prenomAr: "عبد", genre: "M" },
  { region: "Casablanca-Settat", province: "Mohammédia", nom: "Tadlaoui", prenom: "Saïd", nomAr: "التدلاوي", prenomAr: "سعيد", genre: "M" },
  { region: "Casablanca-Settat", province: "Benslimane", nom: "Mezzour", prenom: "Riad", nomAr: "مزور", prenomAr: "رياض", genre: "M" },
  { region: "Casablanca-Settat", province: "Nouaceur", nom: "Zioui", prenom: "Ali", nomAr: "الزبوي", prenomAr: "علي", genre: "M" },
  { region: "Casablanca-Settat", province: "Médiouna", nom: "Amine Chafik", prenom: "Hachim", nomAr: "هشام أمين", prenomAr: "الشفيق", genre: "M" },
  { region: "Casablanca-Settat", province: "Berrechid", nom: "El Ibrahimi", prenom: "Khaled", nomAr: "الإبراهيمي", prenomAr: "خالد", genre: "M" },
  { region: "Casablanca-Settat", province: "El Jadida", nom: "Tarmounia", prenom: "M'barek", nomAr: "الطرمونية", prenomAr: "امبارك", genre: "M" },
  { region: "Casablanca-Settat", province: "Sidi Bennour", nom: "Makhdad", prenom: "Abdelghani", nomAr: "الغني مخداد", prenomAr: "عبد", genre: "M" },
  { region: "Casablanca-Settat", province: "Settat", nom: "Hamdallah", prenom: "Bouchaib", nomAr: "الله بوشعيب", prenomAr: "حمد", genre: "M" },
  { region: "Marrakech-Safi", province: "Gueliz-Nakhil", nom: "El Haouaji", prenom: "Anas", nomAr: "الرزاق أحلوش", prenomAr: "عبد", genre: "M" },
  { region: "Marrakech-Safi", province: "Ménara", nom: "Ahlouch", prenom: "Abderrazak", nomAr: "واعروش", prenomAr: "أحمد", genre: "M" },
  { region: "Marrakech-Safi", province: "Chichaoua", nom: "Ouarouch", prenom: "Ahmed", nomAr: "إدموسى", prenomAr: "محمد", genre: "M" },
  { region: "Marrakech-Safi", province: "Al Haouz", nom: "Idmoussa", prenom: "Mohamed", nomAr: "الفرفار", prenomAr: "العياشي", genre: "M" },
  { region: "Marrakech-Safi", province: "El Kelâa des Sraghna", nom: "Ayachi El Ferfar", prenom: "El", nomAr: "البهي", prenomAr: "حسن", genre: "M" },
  { region: "Marrakech-Safi", province: "Essaouira", nom: "El Maâchi", prenom: "Abdelkbir", nomAr: "سعنان", prenomAr: "هشام", genre: "M" },
  { region: "Marrakech-Safi", province: "Safi", nom: "Saanane", prenom: "Hicham", nomAr: "الكبير المعاشي", prenomAr: "عبد", genre: "M" },
  { region: "Marrakech-Safi", province: "Youssoufia", nom: "El Bahi", prenom: "Hassan", nomAr: "الحسن بنلفقيه", prenomAr: "مولاي", genre: "M" },
  { region: "Drâa-Tafilalet", province: "Errachidia", nom: "Hassan Benlafqih", prenom: "Moulay", nomAr: "التجاني", prenomAr: "عاطف", genre: "M" },
  { region: "Drâa-Tafilalet", province: "Ouarzazate", nom: "Tijani", prenom: "Atif", nomAr: "عدنان", prenomAr: "رشيد", genre: "M" },
  { region: "Drâa-Tafilalet", province: "Midelt", nom: "Adnane", prenom: "Rachid", nomAr: "أوداي", prenomAr: "لحسن", genre: "M" },
  { region: "Drâa-Tafilalet", province: "Tinghir", nom: "Ouday", prenom: "Lahcen", nomAr: "عميري", prenomAr: "ميمون", genre: "M" },
  { region: "Drâa-Tafilalet", province: "Zagora", nom: "Amiri", prenom: "Mimoune", nomAr: "الديواني", prenomAr: "جمال", genre: "M" },
  { region: "Souss-Massa", province: "Agadir-Ida Ou Tanane", nom: "Diwani", prenom: "Jamal", nomAr: "الشناق", prenomAr: "خالد", genre: "M" },
  { region: "Souss-Massa", province: "Inezgane-Aït Melloul", nom: "Chennak", prenom: "Khaled", nomAr: "أروكاغ", prenomAr: "الحسين", genre: "M" },
  { region: "Souss-Massa", province: "Chtouka-Aït Baha", nom: "Azougagh", prenom: "Lahoucine", nomAr: "العزيز البهجة", prenomAr: "عبد", genre: "M" },
  { region: "Souss-Massa", province: "Taroudant-Nord", nom: "El Bahja", prenom: "Abdelaziz", nomAr: "الصمد قيوح", prenomAr: "عبد", genre: "M" },
  { region: "Souss-Massa", province: "Taroudant-Sud", nom: "Kayouh", prenom: "Abdessamad", nomAr: "الباز", prenomAr: "لحسن", genre: "M" },
  { region: "Souss-Massa", province: "Tiznit", nom: "El Baz", prenom: "Lahcen", nomAr: "بوزحاي", prenomAr: "الحسين", genre: "M" },
  { region: "Souss-Massa", province: "Tata", nom: "Bouzhay", prenom: "El Houcine", nomAr: "محمد المصطفى", prenomAr: "شرف الدين", genre: "M" },
  { region: "Guelmim-Oued Noun", province: "Guelmim", nom: "Charafeddine", prenom: "Mustapha", nomAr: "عيان", prenomAr: "بابا", genre: "M" },
  { region: "Guelmim-Oued Noun", province: "Assa-Zag", nom: "Abban", prenom: "Baba", nomAr: "عيان", prenomAr: "بابا", genre: "M" },
  { region: "Guelmim-Oued Noun", province: "Sidi Ifni", nom: "Khaireddine", prenom: "Houcine", nomAr: "خير الدين", prenomAr: "حسين", genre: "M" },
];

/**
 * Kayn'in â€” Store accrÃ©ditation v4
 * Statuts : non_depose | en_attente | accredite
 * Source  : "declaration" (parti) | "candidat" (auto Ã  l'ajout)
 */

import { moroccoRegions, majorParties } from "./parties";
import { useSettingsStore } from "./settingsStore";

// â”€â”€â”€ Types â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

export type AccreditationStatus = "non_depose" | "en_attente" | "accredite" | "refuse";
export type AccreditationSource = "declaration" | "candidat";

export const CATEGORIES_SOCIOPRO = [
  "Fonctionnaire / Agent public",
  "Enseignant / Cadre de l'Ã©ducation",
  "Professions libÃ©rales (mÃ©decin, avocat, ingÃ©nieurâ€¦)",
  "Agriculteur / Ã‰leveur",
  "CommerÃ§ant / Artisan",
  "Chef d'entreprise / Manager",
  "Ã‰tudiant",
  "RetraitÃ©",
  "Sans emploi",
  "Autre",
] as const;

export type CategorieSociopro = (typeof CATEGORIES_SOCIOPRO)[number];

// Date de rÃ©fÃ©rence : jour des Ã©lections
const ELECTION_DATE = new Date("2026-09-23");

export function isJeune(dateNaissance: string): boolean {
  if (!dateNaissance) return false;
  const birth = new Date(dateNaissance);
  const ageAtElection = ELECTION_DATE.getFullYear() - birth.getFullYear()
    - (ELECTION_DATE < new Date(birth.setFullYear(ELECTION_DATE.getFullYear())) ? 1 : 0);
  return ageAtElection < 35;
}

export function computeAge(dob: string): number {
  const birth = new Date(dob);
  return new Date().getFullYear() - birth.getFullYear();
}

export function ageToTranche(age: number): string {
  if (age < 30) return "18â€“29";
  if (age < 40) return "30â€“39";
  if (age < 50) return "40â€“49";
  if (age < 60) return "50â€“59";
  return "60+";
}

export interface CirconscriptionEntry {
  region: string;
  province: string;           // "" si liste rÃ©gionale
  listType: "locale" | "regionale";
  nomCandidat: string;
  prenomCandidat: string;
  nomCandidatAr?: string;
  prenomCandidatAr?: string;
  photoUrl?: string;
  genre: "M" | "F" | "";
  dateNaissance: string;
  email?: string;
  whatsapp?: string;
  trancheAge?: string;
  jeune?: boolean;            // < 35 ans au 23/09/2026
  categorieSociopro?: CategorieSociopro;
  status: AccreditationStatus;
  source?: AccreditationSource;
  dateDepot?: string;
  dateValidation?: string;
  commentaireAdmin?: string;
}

export interface PartyAccreditationData {
  partyAcronym: string;
  updatedAt: string;
  circonscriptions: CirconscriptionEntry[];
}

// â”€â”€â”€ Key localStorage â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const STORE_KEY = "kaynin_accreditation_v9";

// â”€â”€â”€ Seed initial â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
export const rniCandidatesList = [
  // Tanger-Tétouan-Al Hoceïma
  { region: "Tanger-Tétouan-Al Hoceïma", province: "Tétouan", nom: "Talbi Alami", prenom: "Rachid", nomAr: "الطالبي العلمي", prenomAr: "راشيد", genre: "M" },
  { region: "Tanger-Tétouan-Al Hoceïma", province: "Larache", nom: "Simo", prenom: "Mohamed", nomAr: "السيمو", prenomAr: "محمد", genre: "M" },
  { region: "Tanger-Tétouan-Al Hoceïma", province: "Ouezzane", nom: "El Bouari", prenom: "Ahmed", nomAr: "البواري", prenomAr: "أحمد", genre: "M" },
  { region: "Tanger-Tétouan-Al Hoceïma", province: "Fahs-Anjra", nom: "Nouwino", prenom: "Redouane", nomAr: "النوينو", prenomAr: "رضوان", genre: "M" },
  { region: "Tanger-Tétouan-Al Hoceïma", province: "M'diq-Fnideq", nom: "Chaâr", prenom: "Hassan", nomAr: "الشاعر", prenomAr: "حسن", genre: "M" },
  { region: "Tanger-Tétouan-Al Hoceïma", province: "Al Hoceïma", nom: "El Boutahri", prenom: "Karim", nomAr: "البوطاهري", prenomAr: "كريم", genre: "M" },
  { region: "Tanger-Tétouan-Al Hoceïma", province: "Tanger-Assilah", nom: "Boulaïch", prenom: "Abdelouahed", nomAr: "بولعيش", prenomAr: "عبد الواحد", genre: "M" },
  { region: "Tanger-Tétouan-Al Hoceïma", province: "Chefchaouen", nom: "El Omari", prenom: "Abderrahmane", nomAr: "العمري", prenomAr: "عبد الرحمن", genre: "M" },
  // L'Oriental
  { region: "L'Oriental", province: "Figuig", nom: "Benhmed", prenom: "Redouane", nomAr: "بنحمد", prenomAr: "رضوان", genre: "M" },
  { region: "L'Oriental", province: "Driouch", nom: "Boukili", prenom: "Abdellah", nomAr: "البوكيلي", prenomAr: "عبد الله", genre: "M" },
  { region: "L'Oriental", province: "Taourirt", nom: "Benjdi", prenom: "Idriss", nomAr: "بن جدي", prenomAr: "إدريس", genre: "M" },
  { region: "L'Oriental", province: "Berkane", nom: "Sadiki", prenom: "Mohammed", nomAr: "الصديقي", prenomAr: "محمد", genre: "M" },
  { region: "L'Oriental", province: "Jerada", nom: "Toutou", prenom: "Mustapha", nomAr: "توتو", prenomAr: "مصط� ى", genre: "M" },
  // Fès-Meknès
  { region: "Fès-Meknès", province: "Fès-Sud", nom: "Chehim", prenom: "Zina", nomAr: "شهيم", prenomAr: "زينة", genre: "F" },
  { region: "Fès-Meknès", province: "Moulay Yacoub", nom: "Mebrouki", prenom: "Abdelkhalek", nomAr: "المبروكي", prenomAr: "عبد الخالق", genre: "M" },
  { region: "Fès-Meknès", province: "El Hajeb", nom: "Zerrari", prenom: "Najib", nomAr: "الزراري", prenomAr: "نجيب", genre: "M" },
  { region: "Fès-Meknès", province: "Taounate-Tissa", nom: "Salassi", prenom: "Mohammed", nomAr: "السلاسي", prenomAr: "محمد", genre: "M" },
  { region: "Fès-Meknès", province: "Boulemane", nom: "Chouki", prenom: "Mohammed", nomAr: "شوكي", prenomAr: "محمد", genre: "M" },
  { region: "Fès-Meknès", province: "Meknès", nom: "Tahiri", prenom: "Ahmed", nomAr: "طاهري", prenomAr: "أحمد", genre: "M" },
  { region: "Fès-Meknès", province: "Taza", nom: "Sadiki", prenom: "Khalil", nomAr: "الصديقي", prenomAr: "خليل", genre: "M" },
  { region: "Fès-Meknès", province: "Fès-Nord", nom: "Ouazzani", prenom: "Tahami", nomAr: "الوزاني", prenomAr: "التهامي", genre: "M" },
  { region: "Fès-Meknès", province: "Karia-Ghafsay", nom: "Meissouri", prenom: "Abderrahmane", nomAr: "الميسوري", prenomAr: "عبد الرحمن", genre: "M" },
  { region: "Fès-Meknès", province: "Sefrou", nom: "Mandour", prenom: "Youssef", nomAr: "منضور", prenomAr: "يوس� ", genre: "M" },
  { region: "Fès-Meknès", province: "Ifrane", nom: "Hachmi", prenom: "Abderrazak", nomAr: "الهاشمي", prenomAr: "عبد الرزاق", genre: "M" },
  // Rabat-Salé-Kénitra
  { region: "Rabat-Salé-Kénitra", province: "Khémisset-Oulmès", nom: "Bouirmane", prenom: "Abdessalam", nomAr: "البويرماني", prenomAr: "عبد السلام", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Tiflet-Rommani", nom: "Filali", prenom: "Hassan", nomAr: "ال� يلالي", prenomAr: "حسن", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Kénitra", nom: "Berkiya", prenom: "Hatem", nomAr: "برقية", prenomAr: "حاتم", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Gharb", nom: "Gharib", prenom: "Jawad", nomAr: "غريب", prenomAr: "جواد", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Salé-Médina", nom: "Zerrak", prenom: "Omar", nomAr: "الزرق", prenomAr: "عمر", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Salé-Jadida", nom: "Zemzami", prenom: "Abdelkrim", nomAr: "الزمزامي", prenomAr: "عبد الكريم", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Rabat-Chellah", nom: "Bahraoui", prenom: "Alaeddine", nomAr: "البحراوي", prenomAr: "علاء الدين", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Rabat-Océan", nom: "Jmani", prenom: "Taha", nomAr: "الجماني", prenomAr: "طه", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Sidi Slimane", nom: "Sabri", prenom: "Anouar", nomAr: "صبري", prenomAr: "أنور", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Sidi Kacem", nom: "Ghazoui", prenom: "Ahmed", nomAr: "الغزوي", prenomAr: "أحمد", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Skhirate-Témara", nom: "Hamri", prenom: "Rachid", nomAr: "الحمري", prenomAr: "رشيد", genre: "M" },
  // Béni Mellal-Khénifra
  { region: "Béni Mellal-Khénifra", province: "Fquih Ben Salah", nom: "Hanine", prenom: "Saleh", nomAr: "حنين", prenomAr: "صالح", genre: "M" },
  { region: "Béni Mellal-Khénifra", province: "Azilal-Demnate", nom: "Mansouri", prenom: "Rachid", nomAr: "المنصوري", prenomAr: "رشيد", genre: "M" },
  { region: "Béni Mellal-Khénifra", province: "Bzou-Ouaouizeght", nom: "Reddad", prenom: "Mustapha", nomAr: "رداد", prenomAr: "مصط� ى", genre: "M" },
  { region: "Béni Mellal-Khénifra", province: "Khénifra", nom: "Baddou", prenom: "Mohammed", nomAr: "بادو", prenomAr: "محمد", genre: "M" },
  { region: "Béni Mellal-Khénifra", province: "Béni Mellal", nom: "Mansouri", prenom: "Khaled", nomAr: "المنصوري", prenomAr: "خالد", genre: "M" },
  { region: "Béni Mellal-Khénifra", province: "Khouribga", nom: "Archi", prenom: "Hamid", nomAr: "العرشي", prenomAr: "حميد", genre: "M" },
  // Casablanca-Settat
  { region: "Casablanca-Settat", province: "Aïn Sebaâ-Hay Mohammadi", nom: "Benomar", prenom: "Hassan", nomAr: "بن عمر", prenomAr: "حسن", genre: "M" },
  { region: "Casablanca-Settat", province: "Moulay Rachid", nom: "Haddadi", prenom: "Anas", nomAr: "الحدادي", prenomAr: "أنس", genre: "M" },
  { region: "Casablanca-Settat", province: "Sidi Bernoussi", nom: "Ettass", prenom: "Abderrahim", nomAr: "الطاس", prenomAr: "عبد الرحيم", genre: "M" },
  { region: "Casablanca-Settat", province: "Hay Hassani", nom: "Chraïbi", prenom: "Idriss", nomAr: "الشرايبي", prenomAr: "إدريس", genre: "M" },
  { region: "Casablanca-Settat", province: "Al Fida-Mers Sultan", nom: "Adel", prenom: "Yasser", nomAr: "عادل", prenomAr: "ياسر", genre: "M" },
  { region: "Casablanca-Settat", province: "Médiouna", nom: "Noqta", prenom: "Amine", nomAr: "نقطة", prenomAr: "أمين", genre: "M" },
  { region: "Casablanca-Settat", province: "Casablanca-Anfa", nom: "Chebbak", prenom: "Mohammed", nomAr: "الشباك", prenomAr: "محمد", genre: "M" },
  { region: "Casablanca-Settat", province: "Nouaceur", nom: "Rafiq", prenom: "Noureddine", nomAr: "ر� يق", prenomAr: "نور الدين", genre: "M" },
  { region: "Casablanca-Settat", province: "Benslimane", nom: "Akkacha", prenom: "Yassine", nomAr: "عكاشة", prenomAr: "ياسين", genre: "M" },
  { region: "Casablanca-Settat", province: "Ben M'sik", nom: "Kamel", prenom: "Toufiq", nomAr: "كامل", prenomAr: "تو� يق", genre: "M" },
  { region: "Casablanca-Settat", province: "Mohammédia", nom: "Aït Menna", prenom: "Hicham", nomAr: "آيت منا", prenomAr: "هشام", genre: "M" },
  { region: "Casablanca-Settat", province: "Aïn Chock", nom: "Benkirane", prenom: "Mohammed Chafik", nomAr: "بنكيران", prenomAr: "محمد ش� يق", genre: "M" },
  { region: "Casablanca-Settat", province: "Berrechid", nom: "El Kiyaf", prenom: "Saber", nomAr: "الكيا� ", prenomAr: "صابر", genre: "M" },
  { region: "Casablanca-Settat", province: "Sidi Bennour", nom: "Kandil", prenom: "Yasser", nomAr: "قنديل", prenomAr: "ياسر", genre: "M" },
  { region: "Casablanca-Settat", province: "El Jadida", nom: "Rafiq", prenom: "Banasser", nomAr: "ر� يق", prenomAr: "بناصر", genre: "M" },
  { region: "Casablanca-Settat", province: "Settat", nom: "Ghiat", prenom: "Mohammed", nomAr: "غيات", prenomAr: "محمد", genre: "M" },
  // Marrakech-Safi
  { region: "Marrakech-Safi", province: "Gueliz-Nakhil", nom: "Dardari", prenom: "Fayçal", nomAr: "الدرداري", prenomAr: "� يصل", genre: "M" },
  { region: "Marrakech-Safi", province: "Essaouira", nom: "El Othmani", prenom: "Tariq", nomAr: "العثماني", prenomAr: "طارق", genre: "M" },
  { region: "Marrakech-Safi", province: "Youssoufia", nom: "Zidane", prenom: "Karim", nomAr: "زيدان", prenomAr: "كريم", genre: "M" },
  { region: "Marrakech-Safi", province: "Rehamna", nom: "El Ayadi", prenom: "Ali", nomAr: "العيادي", prenomAr: "علي", genre: "M" },
  { region: "Marrakech-Safi", province: "Chichaoua", nom: "Jnah", prenom: "Marouane", nomAr: "جناح", prenomAr: "مروان", genre: "M" },
  { region: "Marrakech-Safi", province: "Ménara", nom: "Chafiki", prenom: "Abdelouahed", nomAr: "الشا� قي", prenomAr: "عبد الواحد", genre: "M" },
  { region: "Marrakech-Safi", province: "Sidi Youssef Ben Ali", nom: "El Kourch", prenom: "Saïd", nomAr: "الكورش", prenomAr: "سعيد", genre: "M" },
  { region: "Marrakech-Safi", province: "El Kelâa des Sraghna", nom: "Benfaïda", prenom: "Mokhtar", nomAr: "بن � ايدة", prenomAr: "مختار", genre: "M" },
  { region: "Marrakech-Safi", province: "Al Haouz", nom: "El Aoujaji", prenom: "Hassan", nomAr: "الأجواجي", prenomAr: "حسن", genre: "M" },
  { region: "Marrakech-Safi", province: "Safi", nom: "Saber", prenom: "Rachid", nomAr: "صابر", prenomAr: "رشيد", genre: "M" },
  // Drâa-Tafilalet
  { region: "Drâa-Tafilalet", province: "Tinghir", nom: "Moujoud", prenom: "Hicham", nomAr: "موجود", prenomAr: "هشام", genre: "M" },
  { region: "Drâa-Tafilalet", province: "Midelt", nom: "Chabaatou", prenom: "Marouane", nomAr: "شباعتو", prenomAr: "مروان", genre: "M" },
  { region: "Drâa-Tafilalet", province: "Zagora", nom: "Oualal", prenom: "El Houssein", nomAr: "وعلال", prenomAr: "الحسين", genre: "M" },
  { region: "Drâa-Tafilalet", province: "Errachidia", nom: "Qraoui", prenom: "Mouha", nomAr: "قراوي", prenomAr: "موحى", genre: "M" },
  { region: "Drâa-Tafilalet", province: "Ouarzazate", nom: "Chiri", prenom: "Youssef", nomAr: "شيري", prenomAr: "يوس� ", genre: "M" },
  // Souss-Massa
  { region: "Souss-Massa", province: "Agadir-Ida Ou Tanane", nom: "Idhali", prenom: "Zina", nomAr: "إدحلي", prenomAr: "زينة", genre: "F" },
  { region: "Souss-Massa", province: "Inezgane-Aït Melloul", nom: "Amine", prenom: "Omar", nomAr: "أمين", prenomAr: "عمر", genre: "M" },
  { region: "Souss-Massa", province: "Chtouka-Aït Baha", nom: "Karam", prenom: "Ismaïl", nomAr: "كرام", prenomAr: "إسماعيل", genre: "M" },
  { region: "Souss-Massa", province: "Tiznit", nom: "Ghazi", prenom: "Abdellah", nomAr: "غازي", prenomAr: "عبد الله", genre: "M" },
  { region: "Souss-Massa", province: "Taroudant-Nord", nom: "Saadi", prenom: "Lahcen", nomAr: "السعدي", prenomAr: "الحسن", genre: "M" },
  { region: "Souss-Massa", province: "Taroudant-Sud", nom: "Bouhdoud", prenom: "Nadia", nomAr: "بوهدود", prenomAr: "نادية", genre: "F" },
  { region: "Souss-Massa", province: "Tata", nom: "Tadounamt", prenom: "Mustapha", nomAr: "تاضونامت", prenomAr: "مصط� ى", genre: "M" },
  // Guelmim-Oued Noun
  { region: "Guelmim-Oued Noun", province: "Sidi Ifni", nom: "Baitas", prenom: "Mustapha", nomAr: "بيتاس", prenomAr: "مصط� ى", genre: "M" },
  { region: "Guelmim-Oued Noun", province: "Assa-Zag", nom: "Houich", prenom: "El Houssein", nomAr: "حويش", prenomAr: "الحسين", genre: "M" },
  { region: "Guelmim-Oued Noun", province: "Tan-Tan", nom: "Oubarka", prenom: "Abdellah", nomAr: "أوبركا", prenomAr: "عبد الله", genre: "M" },
  { region: "Guelmim-Oued Noun", province: "Guelmim", nom: "Bouaïda", prenom: "Nadia", nomAr: "بوعيدة", prenomAr: "نادية", genre: "F" }
];

export const ppsCandidatesList = [
  { region: "Tanger-Tétouan-Al Hoceïma", province: "Tanger-Assilah", nom: "El Mouzeriahi", prenom: "Dahmane", nomAr: "المرزوري", prenomAr: "دحمان", genre: "M" },
  { region: "Tanger-Tétouan-Al Hoceïma", province: "M'diq-Fnideq", nom: "Lazâar", prenom: "Idriss", nomAr: "الزعار", prenomAr: "إدريس", genre: "M" },
  { region: "Tanger-Tétouan-Al Hoceïma", province: "Tétouan", nom: "Rougani", prenom: "Zouhir", nomAr: "الروكاني", prenomAr: "زهير", genre: "M" },
  { region: "Tanger-Tétouan-Al Hoceïma", province: "Al Hoceïma", nom: "Boudra", prenom: "Mohamed", nomAr: "بودرا", prenomAr: "محمد", genre: "M" },
  { region: "Tanger-Tétouan-Al Hoceïma", province: "Chefchaouen", nom: "El Bach", prenom: "Abderrabih", nomAr: "البش", prenomAr: "عبد ربه", genre: "M" },
  { region: "Tanger-Tétouan-Al Hoceïma", province: "Ouezzane", nom: "Semlali", prenom: "Lamia", nomAr: "السملالي", prenomAr: "لمياء", genre: "F" },
  { region: "L'Oriental", province: "Oujda-Angad", nom: "Tiji", prenom: "Ouafaa", nomAr: "التيجي", prenomAr: "وفاء", genre: "F" },
  { region: "L'Oriental", province: "Nador", nom: "Belgacem", prenom: "Mohamed", nomAr: "بلقاسم", prenomAr: "محمد", genre: "M" },
  { region: "L'Oriental", province: "Driouch", nom: "Ouchen", prenom: "Othmane", nomAr: "أوشن", prenomAr: "عثمان", genre: "M" },
  { region: "L'Oriental", province: "Berkane", nom: "El Mahi", prenom: "Fatima Zahra", nomAr: "الماحي", prenomAr: "فاطمة الزهراء", genre: "F" },
  { region: "L'Oriental", province: "Taourirt", nom: "Mihit", prenom: "Mohamed", nomAr: "ميحيت", prenomAr: "محمد", genre: "M" },
  { region: "L'Oriental", province: "Guercif", nom: "El Filali", prenom: "Mhamed", nomAr: "الفيلالي", prenomAr: "محمد", genre: "M" },
  { region: "L'Oriental", province: "Figuig", nom: "Ouhliss", prenom: "Lhoucine", nomAr: "أحليص", prenomAr: "الحسين", genre: "M" },
  { region: "Fès-Meknès", province: "Fès-Sud", nom: "Laqsab", prenom: "Ali", nomAr: "القصب", prenomAr: "علي", genre: "M" },
  { region: "Fès-Meknès", province: "Meknès", nom: "Bakhtaoui", prenom: "Mohamed", nomAr: "بوقاوي", prenomAr: "محمد", genre: "M" },
  { region: "Fès-Meknès", province: "Ifrane", nom: "Mashou", prenom: "Mohamed", nomAr: "مسحوق", prenomAr: "محمد", genre: "M" },
  { region: "Fès-Meknès", province: "Sefrou", nom: "Ben Sâada", prenom: "Badr", nomAr: "بن سعادة", prenomAr: "بدر", genre: "M" },
  { region: "Fès-Meknès", province: "Boulemane", nom: "Hamouni", prenom: "Rachid", nomAr: "حموني", prenomAr: "رشيد", genre: "M" },
  { region: "Fès-Meknès", province: "Taounate-Tissa", nom: "Idrissi Bouzidi", prenom: "Abdellah", nomAr: "الإدريسي البوزيدي", prenomAr: "عبد الله", genre: "M" },
  { region: "Fès-Meknès", province: "Karia-Ghafsay", nom: "Hannaoui", prenom: "Ikram", nomAr: "الحناوي", prenomAr: "إكرام", genre: "F" },
  { region: "Fès-Meknès", province: "Taza", nom: "Abbadi", prenom: "Ahmed", nomAr: "العبادي", prenomAr: "سي أحمد", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Rabat-Océan", nom: "Sassi", prenom: "Rachid", nomAr: "الساسي", prenomAr: "رشيد", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Skhirate-Témara", nom: "Hammari", prenom: "Larbi", nomAr: "الحماري", prenomAr: "العربي", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Kénitra", nom: "Harraq", prenom: "Noureddine", nomAr: "الحراق", prenomAr: "نور الدين", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Khémisset-Oulmès", nom: "Karim", prenom: "Fouad", nomAr: "كريم", prenomAr: "فؤاد", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Tiflet-Rommani", nom: "Lqilaâ", prenom: "Rahhou", nomAr: "وعلي", prenomAr: "رحال", genre: "M" },
  { region: "Béni Mellal-Khénifra", province: "Béni Mellal", nom: "Wahssat", prenom: "Mariam", nomAr: "وحساة", prenomAr: "مريم", genre: "F" },
  { region: "Béni Mellal-Khénifra", province: "Bzou-Ouaouizeght", nom: "Ikken", prenom: "Boubker", nomAr: "إيكن", prenomAr: "بوبكر", genre: "M" },
  { region: "Béni Mellal-Khénifra", province: "Khénifra", nom: "Nadiri", prenom: "Hamza", nomAr: "ناضيري", prenomAr: "حمزة", genre: "M" },
  { region: "Béni Mellal-Khénifra", province: "Khouribga", nom: "Basraoui", prenom: "Allal", nomAr: "البصراوي", prenomAr: "علال", genre: "M" },
  { region: "Casablanca-Settat", province: "Casablanca-Anfa", nom: "Benmoussa", prenom: "Mohamed", nomAr: "بنموسى", prenomAr: "محمد", genre: "M" },
  { region: "Casablanca-Settat", province: "Aïn Chock", nom: "Talal", prenom: "Mohamed", nomAr: "طلال", prenomAr: "محمد", genre: "M" },
  { region: "Casablanca-Settat", province: "Sidi Bernoussi", nom: "Al Hissouni", prenom: "Mustapha", nomAr: "العيسوني", prenomAr: "مصطفى", genre: "M" },
  { region: "Casablanca-Settat", province: "Ben M'sik", nom: "Hajji", prenom: "El Haj", nomAr: "حاجي", prenomAr: "الحاج", genre: "M" },
  { region: "Casablanca-Settat", province: "Mohammédia", nom: "Benbrahim", prenom: "Adil", nomAr: "بنبراهيم", prenomAr: "عادل", genre: "M" },
  { region: "Casablanca-Settat", province: "El Jadida", nom: "Bayazid", prenom: "Aymane", nomAr: "بيازيد", prenomAr: "أيمن", genre: "M" },
  { region: "Casablanca-Settat", province: "Nouaceur", nom: "Boutaleb", prenom: "Rachid", nomAr: "بوطالب", prenomAr: "رشيد", genre: "M" },
  { region: "Casablanca-Settat", province: "Médiouna", nom: "Maanaoui", prenom: "Mustapha", nomAr: "المعناوي", prenomAr: "مصطفى", genre: "M" },
  { region: "Casablanca-Settat", province: "Benslimane", nom: "Dahi", prenom: "Ahmed", nomAr: "الداهي", prenomAr: "أحمد", genre: "M" },
  { region: "Casablanca-Settat", province: "Settat", nom: "Khairat", prenom: "Abdelhadi", nomAr: "خيرات", prenomAr: "عبد الهادي", genre: "M" },
  { region: "Marrakech-Safi", province: "Sidi Youssef Ben Ali", nom: "Himmi", prenom: "Ibrahim", nomAr: "حمي", prenomAr: "إبراهيم", genre: "M" },
  { region: "Marrakech-Safi", province: "Gueliz-Nakhil", nom: "Balissi", prenom: "Ibrahim", nomAr: "باديسي", prenomAr: "إبراهيم", genre: "M" },
  { region: "Marrakech-Safi", province: "Ménara", nom: "Chadid", prenom: "Abdenbi", nomAr: "جديد", prenomAr: "عبد النبي", genre: "M" },
  { region: "Marrakech-Safi", province: "Chichaoua", nom: "Kniza", prenom: "Hamid", nomAr: "قميصا", prenomAr: "حميد", genre: "M" },
  { region: "Marrakech-Safi", province: "Essaouira", nom: "Mersi", prenom: "Othmane", nomAr: "المرسي", prenomAr: "عثمان", genre: "M" },
  { region: "Marrakech-Safi", province: "Rehamna", nom: "Ztoti", prenom: "Abdelali", nomAr: "زطوطي", prenomAr: "عبد الإله", genre: "M" },
  { region: "Marrakech-Safi", province: "Safi", nom: "Abid", prenom: "Abderrazak", nomAr: "عديد", prenomAr: "عبد الرزاق", genre: "M" },
  { region: "Marrakech-Safi", province: "El Kelâa des Sraghna", nom: "Lemaâzez", prenom: "Khalid", nomAr: "المعزز", prenomAr: "خالد", genre: "M" },
  { region: "Drâa-Tafilalet", province: "Ouarzazate", nom: "Akdad", prenom: "Saïd", nomAr: "أقداد", prenomAr: "سعيد", genre: "M" },
  { region: "Drâa-Tafilalet", province: "Midelt", nom: "Aït Rahhou", prenom: "Omar", nomAr: "آيت روهو", prenomAr: "عمر", genre: "M" },
  { region: "Drâa-Tafilalet", province: "Tinghir", nom: "Qacha", prenom: "Mohamed", nomAr: "قاشا", prenomAr: "محمد", genre: "M" },
  { region: "Drâa-Tafilalet", province: "Zagora", nom: "Yassine", prenom: "Youssef", nomAr: "ياسين", prenomAr: "يوسف", genre: "M" },
  { region: "Souss-Massa", province: "Agadir-Ida Ou Tanane", nom: "Oumribet", prenom: "Hassan", nomAr: "أومريبط", prenomAr: "حسن", genre: "M" },
  { region: "Souss-Massa", province: "Inezgane-Aït Melloul", nom: "Zakraoui", prenom: "Mohamed", nomAr: "الزكراوي", prenomAr: "محمد", genre: "M" },
  { region: "Souss-Massa", province: "Chtouka-Aït Baha", nom: "Izzem", prenom: "Soufiane", nomAr: "إيزم", prenomAr: "سفيان", genre: "M" },
  { region: "Souss-Massa", province: "Taroudant-Sud", nom: "Saïyed", prenom: "Jamaâ", nomAr: "سعيد", prenomAr: "جامع", genre: "M" },
  { region: "Souss-Massa", province: "Taroudant-Nord", nom: "Aït Daoud", prenom: "El Hassan", nomAr: "آيت داوود", prenomAr: "الحسن", genre: "M" },
  { region: "Souss-Massa", province: "Tiznit", nom: "Arouhal", prenom: "Khadija", nomAr: "أروهال", prenomAr: "خديجة", genre: "F" },
  { region: "Guelmim-Oued Noun", province: "Guelmim", nom: "Atouif", prenom: "El Houcine", nomAr: "أطويف", prenomAr: "الحسين", genre: "M" },
  { region: "Guelmim-Oued Noun", province: "Tan-Tan", nom: "Ennih", prenom: "Aba Cheikh", nomAr: "لمهالي", prenomAr: "أبا الشيخ", genre: "M" },
  { region: "Guelmim-Oued Noun", province: "Sidi Ifni", nom: "Gougougrine", prenom: "Karim", nomAr: "كوكوكرين", prenomAr: "كريم", genre: "M" }
];

export const pamCandidatesList = [
  // Tanger-Tétouan-Al Hoceïma
  { region: "Tanger-Tétouan-Al Hoceïma", province: "Tanger-Assilah", nom: "El Ghalbzouri", prenom: "Abdellatif", nomAr: "الغلبزوري", prenomAr: "عبد اللطيف", genre: "M" },
  { region: "Tanger-Tétouan-Al Hoceïma", province: "Tétouan", nom: "Ahnnine", prenom: "Mohamed Larbi", nomAr: "أحنين", prenomAr: "محمد العربي", genre: "M" },
  { region: "Tanger-Tétouan-Al Hoceïma", province: "Larache", nom: "Simo", prenom: "Zineb", nomAr: "السيمو", prenomAr: "زينب", genre: "F" },
  { region: "Tanger-Tétouan-Al Hoceïma", province: "Al Hoceïma", nom: "El Hammouti", prenom: "Mohamed", nomAr: "الحموتي", prenomAr: "محمد", genre: "M" },
  { region: "Tanger-Tétouan-Al Hoceïma", province: "M'diq-Fnideq", nom: "Mrabet", prenom: "Mohamed Larbi", nomAr: "المرابط", prenomAr: "محمد العربي", genre: "M" },
  { region: "Tanger-Tétouan-Al Hoceïma", province: "Ouezzane", nom: "Mharchi", prenom: "Larbi", nomAr: "المحرشي", prenomAr: "العربي", genre: "M" },
  { region: "Tanger-Tétouan-Al Hoceïma", province: "Chefchaouen", nom: "El Makkouti", prenom: "Abdelhafid", nomAr: "المكوتي", prenomAr: "عبد الحفيظ", genre: "M" },
  { region: "Tanger-Tétouan-Al Hoceïma", province: "Fahs-Anjra", nom: "Chlaf", prenom: "Abdeslam", nomAr: "الشلاف", prenomAr: "عبد السلام", genre: "M" },

  // Souss-Massa
  { region: "Souss-Massa", province: "Taroudant-Nord", nom: "Ouahbi", prenom: "Abdellatif", nomAr: "وهبي", prenomAr: "عبد اللطيف", genre: "M" },
  { region: "Souss-Massa", province: "Taroudant-Sud", nom: "El Massi", prenom: "Hanane", nomAr: "الماسي", prenomAr: "حنان", genre: "F" },
  { region: "Souss-Massa", province: "Inezgane-Aït Melloul", nom: "Oudmine", prenom: "Mohamed", nomAr: "أودمين", prenomAr: "محمد", genre: "M" },
  { region: "Souss-Massa", province: "Agadir-Ida Ou Tanane", nom: "Ouahbi", prenom: "Hamid", nomAr: "وهبي", prenomAr: "حميد", genre: "M" },
  { region: "Souss-Massa", province: "Chtouka-Aït Baha", nom: "El Farsi", prenom: "El Houssein", nomAr: "الفارسي", prenomAr: "الحسين", genre: "M" },
  { region: "Souss-Massa", province: "Tata", nom: "Tabi", prenom: "Hassan", nomAr: "التابي", prenomAr: "حسان", genre: "M" },

  // Casablanca-Settat
  { region: "Casablanca-Settat", province: "Aïn Chock", nom: "Chafik", prenom: "Abdelhak", nomAr: "شفيق", prenomAr: "عبد الحق", genre: "M" },
  { region: "Casablanca-Settat", province: "Casablanca-Anfa", nom: "Koukous", prenom: "Najwa", nomAr: "كوكوس", prenomAr: "نجوى", genre: "F" },
  { region: "Casablanca-Settat", province: "Al Fida-Mers Sultan", nom: "Benjelloun Touimi", prenom: "Mohamed", nomAr: "بنجلون التويمي", prenomAr: "محمد", genre: "M" },
  { region: "Casablanca-Settat", province: "Aïn Sebaâ-Hay Mohammadi", nom: "El Bitar", prenom: "Adil", nomAr: "البيطار", prenomAr: "عادل", genre: "M" },
  { region: "Casablanca-Settat", province: "Hay Hassani", nom: "Chenguiti", prenom: "Salah Eddine", nomAr: "الشنكيطي", prenomAr: "صلاح الدين", genre: "M" },
  { region: "Casablanca-Settat", province: "Sidi Bernoussi", nom: "Brija", prenom: "Ahmed", nomAr: "بريجة", prenomAr: "أحمد", genre: "M" },
  { region: "Casablanca-Settat", province: "Ben M'sik", nom: "Jdad", prenom: "Mustapha", nomAr: "جداد", prenomAr: "مصطفى", genre: "M" },
  { region: "Casablanca-Settat", province: "Moulay Rachid", nom: "Hamama", prenom: "Mohamed", nomAr: "حماما", prenomAr: "محمد", genre: "M" },
  { region: "Casablanca-Settat", province: "Nouaceur", nom: "Salmani", prenom: "Mohamed", nomAr: "السالمني", prenomAr: "محمد", genre: "M" },
  { region: "Casablanca-Settat", province: "Médiouna", nom: "Bendou", prenom: "Abderrahim", nomAr: "بنضو", prenomAr: "عبد الرحيم", genre: "M" },
  { region: "Casablanca-Settat", province: "Mohammédia", nom: "El Atouani", prenom: "Mohamed Amine", nomAr: "العطواني", prenomAr: "محمد أمين", genre: "M" },
  { region: "Casablanca-Settat", province: "Settat", nom: "Othman", prenom: "Badil", nomAr: "عثمان", prenomAr: "بديل", genre: "M" },
  { region: "Casablanca-Settat", province: "Benslimane", nom: "Ziyadi", prenom: "Karim", nomAr: "الزيادي", prenomAr: "كريم", genre: "M" },
  { region: "Casablanca-Settat", province: "Berrechid", nom: "Baddel", prenom: "Manal", nomAr: "بادل", prenomAr: "منال", genre: "F" },
  { region: "Casablanca-Settat", province: "El Jadida", nom: "Mahdab", prenom: "Mohamed", nomAr: "مهدب", prenomAr: "محمد", genre: "M" },
  { region: "Casablanca-Settat", province: "Sidi Bennour", nom: "Amine", prenom: "El Mostapha", nomAr: "أمين", prenomAr: "المصطفى", genre: "M" },

  // Laâyoune-Sakia El Hamra
  { region: "Laâyoune-Sakia El Hamra", province: "Laâyoune", nom: "Joumani", prenom: "Mohamed Salem", nomAr: "الجماني", prenomAr: "محمد سالم", genre: "M" },
  { region: "Laâyoune-Sakia El Hamra", province: "Es-Semara", nom: "Joumani", prenom: "Sidi Mohamed", nomAr: "الجماني", prenomAr: "سيدي محمد", genre: "M" },
  { region: "Laâyoune-Sakia El Hamra", province: "Tarfaya", nom: "Hartoun", prenom: "Abdelhay", nomAr: "حرطون", prenomAr: "عبد الحي", genre: "M" },
  { region: "Laâyoune-Sakia El Hamra", province: "Boujdour", nom: "Adbada", prenom: "Abdellah", nomAr: "أدبدا", prenomAr: "عبد الله", genre: "M" },

  // Drâa-Tafilalet
  { region: "Drâa-Tafilalet", province: "Ouarzazate", nom: "Lmaoui", prenom: "Imane", nomAr: "لماوي", prenomAr: "إيمان", genre: "F" },

  // Marrakech-Safi
  { region: "Marrakech-Safi", province: "Sidi Youssef Ben Ali", nom: "El Mansouri", prenom: "Fatima Ezzahra", nomAr: "المنصوري", prenomAr: "فاطمة الزهراء", genre: "F" },
  { region: "Marrakech-Safi", province: "Gueliz-Nakhil", nom: "Sabari", prenom: "Mohamed", nomAr: "الصباري", prenomAr: "محمد", genre: "M" },
  { region: "Marrakech-Safi", province: "Ménara", nom: "Hanich", prenom: "Tarik", nomAr: "حنيش", prenomAr: "طارق", genre: "M" },
  { region: "Marrakech-Safi", province: "Chichaoua", nom: "El Mhajri", prenom: "Hicham", nomAr: "المهاجري", prenomAr: "هشام", genre: "M" },
  { region: "Marrakech-Safi", province: "Al Haouz", nom: "Touizi", prenom: "Ahmed", nomAr: "التويزي", prenomAr: "أحمد", genre: "M" },
  { region: "Marrakech-Safi", province: "El Kelâa des Sraghna", nom: "Ouamar", prenom: "Abderrahim", nomAr: "واعمر", prenomAr: "عبد الرحيم", genre: "M" },
  { region: "Marrakech-Safi", province: "Essaouira", nom: "Benjelloun", prenom: "Brahim", nomAr: "بنجلون", prenomAr: "ابراهيم", genre: "M" },
  { region: "Marrakech-Safi", province: "Safi", nom: "Karim", prenom: "Mohamed", nomAr: "كريم", prenomAr: "محمد", genre: "M" },
  { region: "Marrakech-Safi", province: "Rehamna", nom: "El Midaoui", prenom: "Ezzedine", nomAr: "ميداوي", prenomAr: "عز الدين", genre: "M" },
  { region: "Marrakech-Safi", province: "Youssoufia", nom: "Rouijel", prenom: "Youssef", nomAr: "الرويجل", prenomAr: "يوسف", genre: "M" },

  // Others
  { region: "Rabat-Salé-Kénitra", province: "Rabat-Océan", nom: "Bensaid", prenom: "Mohamed Mehdi", nomAr: "بنسعيد", prenomAr: "محمد مهدي", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Rabat-Chellah", nom: "Benbrahim", prenom: "Adib", nomAr: "بنبراهيم", prenomAr: "أديب", genre: "M" },
  { region: "Béni Mellal-Khénifra", province: "Béni Mellal", nom: "Sabri", prenom: "Hicham", nomAr: "صبري", prenomAr: "هشام", genre: "M" }
];

export const pjdCandidatesList = [
  // Regional
  { region: "Tanger-Tétouan-Al Hoceïma", province: "Régionale", nom: "Rouzi", prenom: "Majdouline", nomAr: "الروزي", prenomAr: "مجدولين", genre: "F" },
  { region: "Rabat-Salé-Kénitra", province: "Régionale", nom: "Biki", prenom: "Hind", nomAr: "البيكي", prenomAr: "هند", genre: "F" },
  { region: "Fès-Meknès", province: "Régionale", nom: "Outaleb", prenom: "Samira", nomAr: "أوطالب", prenomAr: "سميرة", genre: "F" },
  { region: "Casablanca-Settat", province: "Régionale", nom: "Ouachay", prenom: "Fatima", nomAr: "وشاي", prenomAr: "فاطمة", genre: "F" },
  { region: "L'Oriental", province: "Régionale", nom: "Sqalli", prenom: "Dounia", nomAr: "الصقلي", prenomAr: "دنيا", genre: "F" },
  { region: "Marrakech-Safi", province: "Régionale", nom: "Rouissi", prenom: "Hind", nomAr: "الرويسي", prenomAr: "هند", genre: "F" },
  { region: "Béni Mellal-Khénifra", province: "Régionale", nom: "Garfad", prenom: "Fouzia", nomAr: "قرفاد", prenomAr: "فوزية", genre: "F" },
  { region: "Drâa-Tafilalet", province: "Régionale", nom: "Maliki", prenom: "Lalla Zhour", nomAr: "ماليكي", prenomAr: "لالة زهور", genre: "F" },
  { region: "Souss-Massa", province: "Régionale", nom: "Akki", prenom: "Sanaa", nomAr: "عكي", prenomAr: "سناء", genre: "F" },
  { region: "Guelmim-Oued Noun", province: "Régionale", nom: "Kouis", prenom: "Fatima Zahra", nomAr: "كويس", prenomAr: "فاطمة الزهراء", genre: "F" },
  { region: "Laâyoune-Sakia El Hamra", province: "Régionale", nom: "Rkibi", prenom: "Hajja", nomAr: "الركيبي", prenomAr: "الحجة", genre: "F" },
  { region: "Dakhla-Oued Ed-Dahab", province: "Régionale", nom: "Hammat Ellil", prenom: "Messaouda", nomAr: "حمة الليل", prenomAr: "مسعودة", genre: "F" },

  // Local
  { region: "L'Oriental", province: "Oujda-Angad", nom: "El Hamel", prenom: "Abdellah", nomAr: "الهامل", prenomAr: "عبد الله", genre: "M" },
  { region: "L'Oriental", province: "Berkane", nom: "El Kaouri", prenom: "Mustapha", nomAr: "القاوري", prenomAr: "مصطفى", genre: "M" },
  { region: "L'Oriental", province: "Figuig", nom: "Tajmouati", prenom: "Abdelouahab", nomAr: "التجمعتي", prenomAr: "عبد الوهاب", genre: "M" },
  { region: "L'Oriental", province: "Nador", nom: "Sadiki", prenom: "Mohamed", nomAr: "الصادقي", prenomAr: "محمد", genre: "M" },
  { region: "L'Oriental", province: "Jerada", nom: "El Hammouri", prenom: "Mohamed", nomAr: "الهموري", prenomAr: "محمد", genre: "M" },
  { region: "L'Oriental", province: "Taourirt", nom: "Hmimouda", prenom: "El Mahjoubi", nomAr: "احميدة", prenomAr: "المحجوبي", genre: "M" },
  { region: "L'Oriental", province: "Driouch", nom: "Benjdi", prenom: "Mohamed", nomAr: "بنجدي", prenomAr: "محمد", genre: "M" },
  { region: "Fès-Meknès", province: "Fès-Nord", nom: "Benchnouf", prenom: "Abdelmajid", nomAr: "بنشنوف", prenomAr: "عبد المجيد", genre: "M" },
  { region: "Fès-Meknès", province: "Fès-Sud", nom: "Khayi", prenom: "Mohamed", nomAr: "خي", prenomAr: "محمد", genre: "M" },
  { region: "Fès-Meknès", province: "Meknès", nom: "Bouanou", prenom: "Abdellah", nomAr: "بووانو", prenomAr: "عبد الله", genre: "M" },
  { region: "Fès-Meknès", province: "Boulemane", nom: "Draissi", prenom: "Mohamed", nomAr: "دريسي", prenomAr: "محمد", genre: "M" },
  { region: "Fès-Meknès", province: "Midelt", nom: "Gzaoui", prenom: "Jilali", nomAr: "كزاوي", prenomAr: "الجيلالي", genre: "M" },
  { region: "Fès-Meknès", province: "Sefrou", nom: "El Mohammadi", prenom: "Oussama", nomAr: "المحمدي", prenomAr: "أسامة", genre: "M" },
  { region: "Fès-Meknès", province: "Taounate-Tissa", nom: "El Asri", prenom: "Ali", nomAr: "العسري", prenomAr: "علي", genre: "M" },
  { region: "Fès-Meknès", province: "Moulay Yacoub", nom: "Hammani", prenom: "Abdelmalek", nomAr: "حماني", prenomAr: "عبد المالك", genre: "M" },
  { region: "Fès-Meknès", province: "El Hajeb", nom: "Essaidi", prenom: "Abdelhak", nomAr: "السعيدي", prenomAr: "عبد الحق", genre: "M" },
  { region: "Fès-Meknès", province: "Ifrane", nom: "Madani", prenom: "Jamal", nomAr: "مدني", prenomAr: "جمال", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Rabat-Océan", nom: "El Khalfi", prenom: "Mustapha", nomAr: "الخلفي", prenomAr: "مصطفى", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Rabat-Chellah", nom: "Et-Tahiri", prenom: "Mohamed", nomAr: "الطاهري", prenomAr: "محمد", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Salé-Médina", nom: "El Kouchi", prenom: "Kamal", nomAr: "الكوشي", prenomAr: "كمال", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Salé-El Jadida", nom: "Hennawi", prenom: "Aziz", nomAr: "هناوي", prenomAr: "عزيز", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Skhirate-Témara", nom: "El Azami El Idrissi", prenom: "Driss", nomAr: "الأزمي الإدريسي", prenomAr: "إدريس", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Kénitra", nom: "El Ibrahimi", prenom: "Mustapha", nomAr: "الإبراهيمي", prenomAr: "مصطفى", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Gharb", nom: "Bedawi", prenom: "Kacem", nomAr: "بدوي", prenomAr: "قاسم", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Tiflet-Rommani", nom: "Es-Slimani", prenom: "Rachid", nomAr: "السليماني", prenomAr: "رشيد", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Khémisset-Oulmès", nom: "Nachite", prenom: "Khalid", nomAr: "نشيط", prenomAr: "خالد", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Sidi Slimane", nom: "En-Naka", prenom: "Mjid", nomAr: "الناكة", prenomAr: "امجيد", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Sidi Kacem", nom: "Bekkawi", prenom: "Abdellah", nomAr: "بكاوي", prenomAr: "عبد الله", genre: "M" },
  { region: "Casablanca-Settat", province: "Aïn Chock", nom: "Maelainine", prenom: "Amina", nomAr: "ماء العينين", prenomAr: "أمينة", genre: "F" },
  { region: "Casablanca-Settat", province: "Moulay Rachid", nom: "Moufidi", prenom: "Mohcine", nomAr: "مفيدي", prenomAr: "محسن", genre: "M" },
  { region: "Casablanca-Settat", province: "Hay Hassani", nom: "Chaouki", prenom: "Samir", nomAr: "شوقي", prenomAr: "سمير", genre: "M" },
  { region: "Casablanca-Settat", province: "Casablanca-Anfa", nom: "Haiker", prenom: "Abdessamad", nomAr: "حيكر", prenomAr: "عبد الصمد", genre: "M" },
  { region: "Casablanca-Settat", province: "Al Fida-Mers Sultan", nom: "Ramid", prenom: "El Fatmi", nomAr: "الرميد", prenomAr: "الفاطمي", genre: "M" },
  { region: "Casablanca-Settat", province: "Hay Mohammadi-Aïn Sebaâ", nom: "Ajkini", prenom: "Rachid", nomAr: "أجكيني", prenomAr: "رشيد", genre: "M" },
  { region: "Casablanca-Settat", province: "Sidi Bernoussi", nom: "Bellatif", prenom: "Omar", nomAr: "بلاطيف", prenomAr: "عمر", genre: "M" },
  { region: "Casablanca-Settat", province: "Mohammédia", nom: "El Mohammadi", prenom: "Thami", nomAr: "المحمدي", prenomAr: "التهامي", genre: "M" },
  { region: "Casablanca-Settat", province: "Nouaceur", nom: "Bennis", prenom: "Mohamed", nomAr: "بنيس", prenomAr: "محمد", genre: "M" },
  { region: "Casablanca-Settat", province: "Médiouna", nom: "Benghridou", prenom: "Hamid", nomAr: "بنغريضو", prenomAr: "حميد", genre: "M" },
  { region: "Casablanca-Settat", province: "El Jadida", nom: "El Idrissi", prenom: "Abouzaid El Mokrie", nomAr: "الإدريسي", prenomAr: "المقرئ أبو زيد", genre: "M" },
  { region: "Casablanca-Settat", province: "Settat", nom: "Fadli", prenom: "Ali", nomAr: "فاضلي", prenomAr: "علي", genre: "M" },
  { region: "Casablanca-Settat", province: "Berrechid", nom: "Zanti", prenom: "Abdelhamid", nomAr: "الزانتي", prenomAr: "عبد الحميد", genre: "M" },
  { region: "Casablanca-Settat", province: "Sidi Bennour", nom: "Belhimer", prenom: "Abderrazzak", nomAr: "بلحيمر", prenomAr: "عبد الرزاق", genre: "M" },
  { region: "Casablanca-Settat", province: "Benslimane", nom: "Benjelloul", prenom: "Mohamed", nomAr: "بنجلول", prenomAr: "محمد", genre: "M" },
  { region: "Marrakech-Safi", province: "Marrakech-Ménara", nom: "Toufella", prenom: "Mohamed", nomAr: "توفلة", prenomAr: "محمد", genre: "M" },
  { region: "Marrakech-Safi", province: "Gueliz-Ennakhil", nom: "El Ouarzazi", prenom: "Mounir", nomAr: "الورزازي", prenomAr: "منير", genre: "M" },
  { region: "Marrakech-Safi", province: "Safi", nom: "Boukmazi", prenom: "Reda", nomAr: "بوكمازي", prenomAr: "رضا", genre: "M" },
  { region: "Marrakech-Safi", province: "El Kelâa des Sraghna", nom: "Toussi", prenom: "Abderrahim", nomAr: "الطوسي", prenomAr: "عبد الرحيم", genre: "M" },
  { region: "Marrakech-Safi", province: "Al Haouz", nom: "Nejmi", prenom: "Saleh", nomAr: "نجمي", prenomAr: "صالح", genre: "M" },
  { region: "Marrakech-Safi", province: "Youssoufia", nom: "Hachimi", prenom: "Rachid", nomAr: "هاشمي", prenomAr: "رشيد", genre: "M" },
  { region: "Marrakech-Safi", province: "Essaouira", nom: "El Gheroua", prenom: "Sami", nomAr: "الغرواع", prenomAr: "سامي", genre: "M" },
  { region: "Drâa-Tafilalet", province: "Ouarzazate", nom: "El Kadi", prenom: "Rachid", nomAr: "القاضي", prenomAr: "رشيد", genre: "M" },
  { region: "Drâa-Tafilalet", province: "Tinghir", nom: "Sadiki", prenom: "Abdelouahid", nomAr: "الصادقي", prenomAr: "عبد الواحد", genre: "M" },
  { region: "Béni Mellal-Khénifra", province: "Béni Mellal", nom: "Ghazi", prenom: "Mohamed Lbridiya", nomAr: "غازي", prenomAr: "محمد لبريديا", genre: "M" },
  { region: "Béni Mellal-Khénifra", province: "Azilal", nom: "Tikoukine", prenom: "Khalid", nomAr: "تيكوكين", prenomAr: "خالد", genre: "M" },
  { region: "Béni Mellal-Khénifra", province: "Azilal", nom: "El Assouli", prenom: "Abdessamad", nomAr: "العسولي", prenomAr: "عبد الصمد", genre: "M" },
  { region: "Béni Mellal-Khénifra", province: "Khénifra", nom: "Bouklou", prenom: "Youssef", nomAr: "بوكلو", prenomAr: "يوسف", genre: "M" },
  { region: "Béni Mellal-Khénifra", province: "Khouribga", nom: "Kabbouri", prenom: "Bouabid", nomAr: "كبوري", prenomAr: "بوعبيد", genre: "M" },
  { region: "Souss-Massa", province: "Agadir-Ida Ou Tanane", nom: "Bakiri", prenom: "Mohamed", nomAr: "باكيري", prenomAr: "محمد", genre: "M" },
  { region: "Souss-Massa", province: "Inezgane-Aït Melloul", nom: "Adrak", prenom: "Ahmed", nomAr: "أدراق", prenomAr: "أحمد", genre: "M" },
  { region: "Souss-Massa", province: "Taroudannt-Sud", nom: "Limoun", prenom: "Abdelghani", nomAr: "ليمون", prenomAr: "عبد الغني", genre: "M" },
  { region: "Souss-Massa", province: "Taroudannt-Nord", nom: "Aslimane", prenom: "Moulay Mohamed Ait Bella", nomAr: "أسليمان", prenomAr: "مولاي محمد آيت بلا", genre: "M" },
  { region: "Souss-Massa", province: "Tiznit", nom: "Brik", prenom: "Omar", nomAr: "بريك", prenomAr: "عمر", genre: "M" },
  { region: "Souss-Massa", province: "Chtouka-Aït Baha", nom: "Lachgar", prenom: "Mohamed", nomAr: "لشكر", prenomAr: "محمد", genre: "M" },
  { region: "Souss-Massa", province: "Tata", nom: "Ibrahim", prenom: "Ahmed", nomAr: "إبراهيم", prenomAr: "أحمد", genre: "M" },
  { region: "Guelmim-Oued Noun", province: "Sidi Ifni", nom: "Issam", prenom: "Mohamed", nomAr: "عصام", prenomAr: "محمد", genre: "M" },
  { region: "Guelmim-Oued Noun", province: "Guelmim", nom: "Berrou", prenom: "Zakaria", nomAr: "برو", prenomAr: "زكرياء", genre: "M" },
  { region: "Guelmim-Oued Noun", province: "Tan-Tan", nom: "Abladi", prenom: "Batoul", nomAr: "أبلاضي", prenomAr: "البتول", genre: "F" },
  { region: "Laâyoune-Sakia El Hamra", province: "Es-Semara", nom: "El Jadida", prenom: "Yassine Ait", nomAr: "الجديدة", prenomAr: "ياسين آيت", genre: "M" },
];

export const usfpCandidatesList = [
  // Rabat-Salé-Kénitra
  { region: "Rabat-Salé-Kénitra", province: "Rabat-Chellah", nom: "Lachgar", prenom: "Hassan", nomAr: "لشكر", prenomAr: "حسن", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Rabat-Océan", nom: "Benatiq", prenom: "Abdelkarim", nomAr: "بنعتيق", prenomAr: "عبد الكريم", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Kénitra", nom: "El Karji", prenom: "Aicha", nomAr: "الكرجي", prenomAr: "عائشة", genre: "F" },
  { region: "Casablanca-Settat", province: "Benslimane", nom: "Samat", prenom: "Hassan", nomAr: "السماط", prenomAr: "حسن", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Kénitra", nom: "Bayhou", prenom: "Taha", nomAr: "بيحو", prenomAr: "طه", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Sidi Kacem", nom: "Laassel", prenom: "Hicham", nomAr: "لعسل", prenomAr: "هشام", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Skhirate-Témara", nom: "Saadi", prenom: "Khalil", nomAr: "السعدي", prenomAr: "خليل", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Khémisset-Oulmès", nom: "Farchioui", prenom: "Rachid", nomAr: "الفرشيوي", prenomAr: "رشيد", genre: "M" },
  { region: "Rabat-Salé-Kénitra", province: "Tiflet-Rommani", nom: "Bahizat", prenom: "Abdelhafid", nomAr: "بهيزات", prenomAr: "عبد الحفيظ", genre: "M" },

  // Casablanca-Settat
  { region: "Casablanca-Settat", province: "Mohammédia", nom: "Mezzouari", prenom: "Ahmed El Mehdi", nomAr: "مزواري", prenomAr: "أحمد المهدي", genre: "M" },
  { region: "Casablanca-Settat", province: "Casablanca-Anfa", nom: "Chrif", prenom: "Latifa", nomAr: "الشريف", prenomAr: "لطيفة", genre: "F" },
  { region: "Casablanca-Settat", province: "El Jadida", nom: "Fatmi", prenom: "Moulay El Mehdi", nomAr: "الفاطمي", prenomAr: "مولاي المهدي", genre: "M" },
  { region: "Casablanca-Settat", province: "Settat", nom: "Namli", prenom: "Said", nomAr: "النملي", prenomAr: "سعيد", genre: "M" },
  { region: "Casablanca-Settat", province: "Sidi Bennour", nom: "Abou El Faraj", prenom: "Mohamed", nomAr: "أبو الفرج", prenomAr: "محمد", genre: "M" },
  { region: "Casablanca-Settat", province: "Nouaceur", nom: "El Kellaa", prenom: "Aicha", nomAr: "الكلاع", prenomAr: "عائشة", genre: "F" },
  { region: "Casablanca-Settat", province: "Hay Mohammadi-Aïn Sebaâ", nom: "Rachdi", prenom: "Marouane", nomAr: "الراشدي", prenomAr: "مروان", genre: "M" },
  { region: "Casablanca-Settat", province: "Hay Hassani", nom: "Amama", prenom: "Marouane", nomAr: "عمامة", prenomAr: "مروان", genre: "M" },
  { region: "Casablanca-Settat", province: "Sidi Othmane", nom: "El Mostakfi", prenom: "Abdellatif", nomAr: "المستكفي", prenomAr: "عبد اللطيف", genre: "M" },
  { region: "Casablanca-Settat", province: "Ben M'sik", nom: "Nkouti", prenom: "Mohamed", nomAr: "نكوطي", prenomAr: "محمد", genre: "M" },
  { region: "Casablanca-Settat", province: "Al Fida-Mers Sultan", nom: "Mahfoud", prenom: "Anis", nomAr: "محفوظ", prenomAr: "أنيس", genre: "M" },
  { region: "Casablanca-Settat", province: "Aïn Chock", nom: "Bouchikhi", prenom: "Badr", nomAr: "البوشيخي", prenomAr: "بدر", genre: "M" },
  { region: "Casablanca-Settat", province: "Médiouna", nom: "El Idrissi", prenom: "Zakaria", nomAr: "الإدريسي", prenomAr: "زكرياء", genre: "M" },
  { region: "Casablanca-Settat", province: "Sidi Bernoussi", nom: "Akerdi", prenom: "Said", nomAr: "أكردي", prenomAr: "سعيد", genre: "M" },

  // Fès-Meknès
  { region: "Fès-Meknès", province: "Sefrou", nom: "Chtibi", prenom: "Driss", nomAr: "شطيبي", prenomAr: "إدريس", genre: "M" },
  { region: "Fès-Meknès", province: "Fès-Nord", nom: "Jaouhar", prenom: "Yassine", nomAr: "جوهر", prenomAr: "ياسين", genre: "M" },
  { region: "Fès-Meknès", province: "Ifrane", nom: "Aherhar", prenom: "Benasser", nomAr: "أهرهار", prenomAr: "بناصر", genre: "M" },
  { region: "Fès-Meknès", province: "Taza", nom: "Ajtiou", prenom: "Mohamed", nomAr: "أجطيو", prenomAr: "محمد", genre: "M" },
  { region: "Fès-Meknès", province: "El Hajeb", nom: "Ben Sat", prenom: "Omar", nomAr: "بن صاط", prenomAr: "عمر", genre: "M" },
  { region: "Fès-Meknès", province: "Taounate-Tissa", nom: "Zouhair", prenom: "Khalid", nomAr: "الزهير", prenomAr: "خالد", genre: "M" },

  // Marrakech-Safi
  { region: "Marrakech-Safi", province: "Essaouira", nom: "Mellal", prenom: "Mohamed", nomAr: "ملال", prenomAr: "محمد", genre: "M" },
  { region: "Marrakech-Safi", province: "Rehamna", nom: "El Akroud", prenom: "Hamid", nomAr: "العكرود", prenomAr: "حميد", genre: "M" },
  { region: "Marrakech-Safi", province: "Safi", nom: "Ajdia", prenom: "Mohamed", nomAr: "أجدية", prenomAr: "محمد", genre: "M" },
  { region: "Marrakech-Safi", province: "El Kelâa des Sraghna", nom: "Toumi", prenom: "Moulay Ahmed", nomAr: "التومي", prenomAr: "مولاي أحمد", genre: "M" },
  { region: "Marrakech-Safi", province: "Chichaoua", nom: "Akdach", prenom: "Abdessamad", nomAr: "أكضاش", prenomAr: "عبد الصمد", genre: "M" },

  // Tanger-Tétouan-Al Hoceïma
  { region: "Tanger-Tétouan-Al Hoceïma", province: "Chefchaouen", nom: "Bakkali", prenom: "Lamine", nomAr: "البقالي", prenomAr: "الأمين", genre: "M" },
  { region: "Tanger-Tétouan-Al Hoceïma", province: "Al Hoceïma", nom: "Amghar", prenom: "Abdelhak", nomAr: "أمغار", prenomAr: "عبد الحق", genre: "M" },
  { region: "Tanger-Tétouan-Al Hoceïma", province: "Larache", nom: "El Hammani", prenom: "Mohamed", nomAr: "الحماني", prenomAr: "محمد", genre: "M" },
  { region: "Tanger-Tétouan-Al Hoceïma", province: "Tanger-Assilah", nom: "Ben Tahir", prenom: "Abdelkader", nomAr: "بن طاهر", prenomAr: "عبد القادر", genre: "M" },
  { region: "Tanger-Tétouan-Al Hoceïma", province: "Tétouan", nom: "Deraq", prenom: "Hamid", nomAr: "دراق", prenomAr: "حميد", genre: "M" },

  // Guelmim-Oued Noun
  { region: "Guelmim-Oued Noun", province: "Tan-Tan", nom: "Zelfi", prenom: "Aouicha", nomAr: "زلفي", prenomAr: "عويشة", genre: "F" },
  { region: "Guelmim-Oued Noun", province: "Assa-Zag", nom: "Abba", prenom: "Mahmoud", nomAr: "عبا", prenomAr: "محمود", genre: "M" },

  // Drâa-Tafilalet
  { region: "Drâa-Tafilalet", province: "Errachidia", nom: "Alaoui", prenom: "Moulay El Mehdi", nomAr: "العالوي", prenomAr: "مولاي المهدي", genre: "M" },
  { region: "Drâa-Tafilalet", province: "Zagora", nom: "Chahid", prenom: "Abderrahim", nomAr: "شهيد", prenomAr: "عبد الرحيم", genre: "M" }
];

function buildSeedData(): PartyAccreditationData[] {
  const data: PartyAccreditationData[] = [];

  majorParties.forEach((party) => {
    const circs: CirconscriptionEntry[] = [];
    
    moroccoRegions.forEach((region) => {
      region.provinces.forEach((province) => {
        let isRNIAccredited = false;
        let rniCandidate = null;
        let isPPSAccredited = false;
        let ppsCandidate = null;
        let isPAMAccredited = false;
        let pamCandidate = null;
        let isPJDAccredited = false;
        let pjdCandidate = null;
        let isUSFPAccredited = false;
        let isPIAccredited = false;
        let usfpCandidate = null;
        let piCandidate = null;

        if (party.acronym === "RNI") {
          rniCandidate = rniCandidatesList.find(c => c.region === region.name && c.province === province);
          if (rniCandidate) {
            isRNIAccredited = true;
          }
        }
        
        if (party.acronym === "PPS") {
          ppsCandidate = ppsCandidatesList.find(c => c.region === region.name && c.province === province);
          if (ppsCandidate) {
            isPPSAccredited = true;
          }
        }
        
        if (party.acronym === "PAM") {
          pamCandidate = pamCandidatesList.find(c => c.region === region.name && c.province === province);
          if (pamCandidate) {
            isPAMAccredited = true;
          }
        }

        if (party.acronym === "PJD") {
          pjdCandidate = pjdCandidatesList.find(c => c.region === region.name && c.province === province);
          if (pjdCandidate) {
            isPJDAccredited = true;
          }
        }

        if (party.acronym === "USFP") {
          usfpCandidate = usfpCandidatesList.find(c => c.region === region.name && c.province === province);
          if (usfpCandidate) {
            isUSFPAccredited = true;
          }
        }

        if (party.acronym === "PI") {
          piCandidate = piCandidatesList.find(c => c.region === region.name && c.province === province);
          if (piCandidate) {
            isPIAccredited = true;
          }
        }

        if (party.acronym === "PPS") {
          ppsCandidate = ppsCandidatesList.find(c => c.region === region.name && c.province === province);
          if (ppsCandidate) {
            isPPSAccredited = true;
          }
        }

        if (isRNIAccredited && rniCandidate) {
          circs.push({
            region: region.name,
            province,
            listType: "locale",
            nomCandidat: rniCandidate.nom,
            prenomCandidat: rniCandidate.prenom,
            nomCandidatAr: rniCandidate.nomAr,
            prenomCandidatAr: rniCandidate.prenomAr,
            genre: rniCandidate.genre as "M" | "F",
            dateNaissance: "1980-01-01", // Default DOB since not provided
            trancheAge: "40-49",
            jeune: false,
            categorieSociopro: "Autre",
            status: "accredite",
            source: "candidat",
            dateDepot: "2026-06-05",
            dateValidation: "2026-06-05",
          });
        } else if (isPPSAccredited && ppsCandidate) {
          circs.push({
            region: region.name,
            province,
            listType: "locale",
            nomCandidat: ppsCandidate.nom,
            prenomCandidat: ppsCandidate.prenom,
            nomCandidatAr: ppsCandidate.nomAr,
            prenomCandidatAr: ppsCandidate.prenomAr,
            genre: ppsCandidate.genre as "M" | "F",
            dateNaissance: "1980-01-01", // Default DOB since not provided
            trancheAge: "40-49",
            jeune: false,
            categorieSociopro: "Autre",
            status: "accredite",
            source: "candidat",
            dateDepot: "2026-07-12",
            dateValidation: "2026-07-12",
          });
        } else if (isPAMAccredited && pamCandidate) {
          circs.push({
            region: region.name,
            province,
            listType: "locale",
            nomCandidat: pamCandidate.nom,
            prenomCandidat: pamCandidate.prenom,
            nomCandidatAr: pamCandidate.nomAr,
            prenomCandidatAr: pamCandidate.prenomAr,
            genre: pamCandidate.genre as "M" | "F",
            dateNaissance: "1980-01-01", // Default DOB since not provided
            trancheAge: "40-49",
            jeune: false,
            categorieSociopro: "Autre",
            status: "accredite",
            source: "candidat",
            dateDepot: "2026-07-12",
            dateValidation: "2026-07-12",
          });
        } else if (isPJDAccredited && pjdCandidate) {
          circs.push({
            region: region.name,
            province,
            listType: "locale",
            nomCandidat: pjdCandidate.nom,
            prenomCandidat: pjdCandidate.prenom,
            nomCandidatAr: pjdCandidate.nomAr,
            prenomCandidatAr: pjdCandidate.prenomAr,
            genre: pjdCandidate.genre as "M" | "F",
            dateNaissance: "1980-01-01",
            trancheAge: "40-49",
            jeune: false,
            categorieSociopro: "Autre",
            status: "accredite",
            source: "candidat",
            dateDepot: "2026-07-12",
            dateValidation: "2026-07-12",
          });
        } else if (isUSFPAccredited && usfpCandidate) {
          circs.push({
            region: region.name,
            province,
            listType: "locale",
            nomCandidat: usfpCandidate.nom,
            prenomCandidat: usfpCandidate.prenom,
            nomCandidatAr: usfpCandidate.nomAr,
            prenomCandidatAr: usfpCandidate.prenomAr,
            genre: usfpCandidate.genre as "M" | "F",
            dateNaissance: "1980-01-01",
            trancheAge: "40-49",
            jeune: false,
            categorieSociopro: "Autre",
            status: "accredite",
            source: "candidat",
            dateDepot: "2026-07-12",
            dateValidation: "2026-07-12",
          });
        } else if (isPIAccredited && piCandidate) {
          circs.push({
            region: region.name,
            province,
            listType: "locale",
            nomCandidat: piCandidate.nom,
            prenomCandidat: piCandidate.prenom,
            nomCandidatAr: piCandidate.nomAr,
            prenomCandidatAr: piCandidate.prenomAr,
            genre: piCandidate.genre as "M" | "F",
            dateNaissance: "1980-01-01",
            trancheAge: "40-49",
            jeune: false,
            categorieSociopro: "Autre",
            status: "accredite",
            source: "candidat",
            dateDepot: "2026-07-23",
            dateValidation: "2026-07-23",
          });
        } else {
          circs.push({
            region: region.name,
            province,
            listType: "locale",
            nomCandidat: "",
            prenomCandidat: "",
            genre: "",
            dateNaissance: "",
            status: "en_attente",
            source: "declaration",
          });
        }
      });

      // Regional list (Women) - just add empty/waiting for all
      circs.push({
        region: region.name,
        province: "",
        listType: "regionale",
        nomCandidat: "",
        prenomCandidat: "",
        genre: "",
        dateNaissance: "",
        status: "en_attente",
        source: "declaration",
      });
    });

    data.push({ partyAcronym: party.acronym, updatedAt: new Date().toISOString(), circonscriptions: circs });
  });

  return data;
}

// â”€â”€â”€ Fonctions d'accÃ¨s â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€


export function getAllAccreditationData(): PartyAccreditationData[] {
  try {
    const raw = localStorage.getItem(STORE_KEY);
    if (raw) return JSON.parse(raw);
  } catch {}
  const seed = buildSeedData();
  try {
    localStorage.setItem(STORE_KEY, JSON.stringify(seed));
  } catch (e) {
    console.warn("Failed to write seed data to localStorage", e);
  }
  return seed;
}

export function getPartyAccreditationData(partyAcronym: string): PartyAccreditationData | null {
  const all = getAllAccreditationData();
  return all.find(p => p.partyAcronym === partyAcronym) || null;
}

export function savePartyAccreditationData(data: PartyAccreditationData): void {
  const all = getAllAccreditationData();
  const idx = all.findIndex(p => p.partyAcronym === data.partyAcronym);
  const updated = { ...data, updatedAt: new Date().toISOString() };
  if (idx >= 0) all[idx] = updated; else all.push(updated);
  localStorage.setItem(STORE_KEY, JSON.stringify(all));
  useSettingsStore.getState().updateSetting(STORE_KEY, JSON.stringify(all));
}

/**
 * Auto-accrÃ©ditation lors de l'ajout d'un candidat par le parti.
 * Le candidat validÃ© par le parti = accredite automatiquement.
 */
export function autoAccreditCandidate(
  partyAcronym: string,
  entry: {
    region: string;
    province: string;
    listType: "locale" | "regionale";
    nomCandidat: string;
    prenomCandidat: string;
    nomCandidatAr?: string;
    prenomCandidatAr?: string;
    genre: "M" | "F" | "";
    dateNaissance: string;
    email?: string;
    whatsapp?: string;
    categorieSociopro?: CategorieSociopro;
  }
): void {
  const all = getAllAccreditationData();
  let partyData = all.find(p => p.partyAcronym === partyAcronym);
  if (!partyData) {
    partyData = { partyAcronym, updatedAt: new Date().toISOString(), circonscriptions: [] };
    all.push(partyData);
  }

  const age = computeAge(entry.dateNaissance);
  const newEntry: CirconscriptionEntry = {
    ...entry,
    trancheAge: ageToTranche(age),
    jeune: isJeune(entry.dateNaissance),
    status: "accredite",
    source: "candidat",
    dateDepot: new Date().toISOString().slice(0, 10),
    dateValidation: new Date().toISOString().slice(0, 10),
  };

  const idx = partyData.circonscriptions.findIndex(
    c => c.region === entry.region && c.province === entry.province && c.listType === entry.listType
  );
  if (idx >= 0) {
    partyData.circonscriptions[idx] = { ...partyData.circonscriptions[idx], ...newEntry };
  } else {
    partyData.circonscriptions.push(newEntry);
  }
  partyData.updatedAt = new Date().toISOString();
  localStorage.setItem(STORE_KEY, JSON.stringify(all));
  useSettingsStore.getState().updateSetting(STORE_KEY, JSON.stringify(all));
}

export function adminUpdateCirconscription(
  partyAcronym: string,
  region: string,
  province: string,
  listType: "locale" | "regionale",
  patch: Partial<CirconscriptionEntry>
): void {
  const all = getAllAccreditationData();
  const partyIdx = all.findIndex(p => p.partyAcronym === partyAcronym);
  if (partyIdx < 0) return;
  const circIdx = all[partyIdx].circonscriptions.findIndex(
    c => c.region === region && c.province === province && c.listType === listType
  );
  if (circIdx >= 0) {
    all[partyIdx].circonscriptions[circIdx] = {
      ...all[partyIdx].circonscriptions[circIdx],
      ...patch,
      dateValidation: new Date().toISOString().slice(0, 10),
    };
  }
  all[partyIdx].updatedAt = new Date().toISOString();
  localStorage.setItem(STORE_KEY, JSON.stringify(all));
  useSettingsStore.getState().updateSetting(STORE_KEY, JSON.stringify(all));
}

// â”€â”€â”€ Helpers BaromÃ¨tres â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

export interface BarometerPartyStats {
  partyAcronym: string;
  total: number;
  accredited: number;
  accreditedLocale: number;
  accreditedRegionale: number;
  en_attente: number;
  non_depose: number;
  refuse: number;
  hommes: number;
  femmes: number;
  jeunes: number;
  byTranche: Record<string, number>;
  bySociopro: Record<string, number>;
}

export interface BarometerRegionStats {
  region: string;
  total: number;
  accredited: number;
  en_attente: number;
  hommes: number;
  femmes: number;
  jeunes: number;
  byTranche: Record<string, number>;
  bySociopro: Record<string, number>;
  byParty: Record<string, { total: number; accredited: number }>;
}

export interface BarometerProvinceStats {
  province: string;
  total: number;
  accredited: number;
  en_attente: number;
  hommes: number;
  femmes: number;
  jeunes: number;
}

export const AGE_TRANCHES = ["18â€“29", "30â€“39", "40â€“49", "50â€“59", "60+"];

export function computeBarometerData() {
  const all = getAllAccreditationData();

  // --- Par Parti ---
  const byParty: BarometerPartyStats[] = all.map(pd => {
    const circs = pd.circonscriptions;
    const byTranche: Record<string, number> = Object.fromEntries(AGE_TRANCHES.map(t => [t, 0]));
    const bySociopro: Record<string, number> = Object.fromEntries(CATEGORIES_SOCIOPRO.map(c => [c, 0]));
    circs.forEach(c => {
      if (c.trancheAge) byTranche[c.trancheAge] = (byTranche[c.trancheAge] || 0) + 1;
      if (c.categorieSociopro) bySociopro[c.categorieSociopro] = (bySociopro[c.categorieSociopro] || 0) + 1;
    });
    return {
      partyAcronym: pd.partyAcronym,
      total: circs.length,
      accredited: circs.filter(c => c.status === "accredite").length,
      accreditedLocale: circs.filter(c => c.status === "accredite" && c.listType === "locale").length,
      accreditedRegionale: circs.filter(c => c.status === "accredite" && c.listType === "regionale").length,
      en_attente: circs.filter(c => c.status === "en_attente").length,
      non_depose: circs.filter(c => c.status === "non_depose").length,
      refuse: circs.filter(c => c.status === "refuse").length,
      hommes: circs.filter(c => c.genre === "M").length,
      femmes: circs.filter(c => c.genre === "F").length,
      jeunes: circs.filter(c => c.jeune === true).length,
      byTranche,
      bySociopro,
    };
  });

  // --- Par RÃ©gion ---
  const regionMap: Record<string, BarometerRegionStats> = {};
  moroccoRegions.forEach(r => {
    regionMap[r.name] = {
      region: r.name,
      total: 0, accredited: 0, en_attente: 0,
      hommes: 0, femmes: 0, jeunes: 0,
      byTranche: Object.fromEntries(AGE_TRANCHES.map(t => [t, 0])),
      bySociopro: Object.fromEntries(CATEGORIES_SOCIOPRO.map(c => [c, 0])),
      byParty: {},
    };
  });

  all.forEach(pd => {
    pd.circonscriptions.forEach(c => {
      const rs = regionMap[c.region];
      if (!rs) return;
      rs.total++;
      if (c.status === "accredite") rs.accredited++;
      else if (c.status === "en_attente") rs.en_attente++;
      if (c.genre === "M") rs.hommes++;
      else if (c.genre === "F") rs.femmes++;
      if (c.jeune) rs.jeunes++;
      if (c.trancheAge) rs.byTranche[c.trancheAge] = (rs.byTranche[c.trancheAge] || 0) + 1;
      if (c.categorieSociopro) rs.bySociopro[c.categorieSociopro] = (rs.bySociopro[c.categorieSociopro] || 0) + 1;
      if (!rs.byParty[pd.partyAcronym]) rs.byParty[pd.partyAcronym] = { total: 0, accredited: 0 };
      rs.byParty[pd.partyAcronym].total++;
      if (c.status === "accredite") rs.byParty[pd.partyAcronym].accredited++;
    });
  });

  const byRegion = Object.values(regionMap);

  // --- Globaux ---
  const globalGenre = { hommes: 0, femmes: 0, total: 0 };
  const globalAge: Record<string, number> = Object.fromEntries(AGE_TRANCHES.map(t => [t, 0]));
  const globalSociopro: Record<string, number> = Object.fromEntries(CATEGORIES_SOCIOPRO.map(c => [c, 0]));
  let globalJeunes = 0;
  let globalTotal = 0;

  all.forEach(pd => pd.circonscriptions.forEach(c => {
    globalTotal++;
    if (c.genre === "M") globalGenre.hommes++;
    else if (c.genre === "F") globalGenre.femmes++;
    globalGenre.total++;
    if (c.trancheAge) globalAge[c.trancheAge] = (globalAge[c.trancheAge] || 0) + 1;
    if (c.categorieSociopro) globalSociopro[c.categorieSociopro] = (globalSociopro[c.categorieSociopro] || 0) + 1;
    if (c.jeune) globalJeunes++;
  }));

  return { byParty, byRegion, globalGenre, globalAge, globalSociopro, globalJeunes, globalTotal };
}

export function computeProvinceStats(region: string): BarometerProvinceStats[] {
  const all = getAllAccreditationData();
  const reg = moroccoRegions.find(r => r.name === region);
  if (!reg) return [];

  return reg.provinces.map(province => {
    const stats: BarometerProvinceStats = { province, total: 0, accredited: 0, en_attente: 0, hommes: 0, femmes: 0, jeunes: 0 };
    all.forEach(pd => {
      pd.circonscriptions.filter(c => c.region === region && c.province === province).forEach(c => {
        stats.total++;
        if (c.status === "accredite") stats.accredited++;
        else if (c.status === "en_attente") stats.en_attente++;
        if (c.genre === "M") stats.hommes++;
        else if (c.genre === "F") stats.femmes++;
        if (c.jeune) stats.jeunes++;
      });
    });
    return stats;
  });
}


